import { CheckCircle2, Clock, XCircle } from 'lucide-react';

import { DashboardLayout } from '@/components/dashboard/DashboardLayout';
import { PageHeader } from '@/components/dashboard/PageHeader';
import { validations } from '@/lib/mockData';
import { cn } from '@/lib/utils';

const statusIcon = {
  validated: <CheckCircle2 className="size-3.5 text-emerald-600" />,
  pending: <Clock className="size-3.5 text-amber-600" />,
  expired: <XCircle className="size-3.5 text-muted-foreground" />,
};
const statusLabel = { validated: 'Validé', pending: 'En attente', expired: 'Expiré' };

const HotesseHistorique = () => (
  <DashboardLayout
    role="hotesse"
    user={{ name: 'Anike Aya', subtitle: 'Hôtesse Admin', initials: 'AA' }}
  >
    <PageHeader
      title="Historique des validations"
      subtitle="Tous les lots remis sur la campagne en cours."
    />

    <div className="overflow-hidden rounded-2xl border border-border bg-card shadow-soft">
      <table className="w-full text-sm">
        <thead className="border-b border-border bg-muted/50">
          <tr className="text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            <th className="px-5 py-3">Participant</th>
            <th className="px-5 py-3">Lot</th>
            <th className="px-5 py-3">Code</th>
            <th className="px-5 py-3">Heure</th>
            <th className="px-5 py-3 text-right">Statut</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {validations.map(v => (
            <tr key={v.id} className="hover:bg-muted/30">
              <td className="px-5 py-3 font-medium">{v.participantName}</td>
              <td className="px-5 py-3 text-muted-foreground">{v.prize}</td>
              <td className="px-5 py-3">
                <code className="rounded-md bg-muted px-2 py-1 font-mono text-xs">{v.code}</code>
              </td>
              <td className="px-5 py-3 text-muted-foreground">{v.time}</td>
              <td className="px-5 py-3 text-right">
                <span
                  className={cn(
                    'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold',
                    v.status === 'validated' &&
                      'border-emerald-500/30 bg-emerald-500/10 text-emerald-700',
                    v.status === 'pending' && 'border-amber-500/30 bg-amber-500/10 text-amber-700',
                    v.status === 'expired' && 'border-border bg-muted text-muted-foreground'
                  )}
                >
                  {statusIcon[v.status]}
                  {statusLabel[v.status]}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </DashboardLayout>
);

export default HotesseHistorique;
